var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:{ selected: _vm.selected }},[_c('nice-label',{attrs:{"label":_vm.label}}),_c('div',{staticClass:"value",domProps:{"innerHTML":_vm._s(_vm.value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }